import { render, staticRenderFns } from "./order-manage-list.vue?vue&type=template&id=3b7f5c39&scoped=true&"
import script from "./order-manage-list.vue?vue&type=script&lang=js&"
export * from "./order-manage-list.vue?vue&type=script&lang=js&"
import style0 from "./order-manage-list.vue?vue&type=style&index=0&id=3b7f5c39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7f5c39",
  null
  
)

export default component.exports